import React from "react";
import { ShieldCheck, Check } from "lucide-react";

const POINTS = [
  "Just tell us your printer or what you need.",
  "We'll make sure it's correct.",
];

export default function SuppliesReassurance() {
  return (
    <section
      data-testid="supplies-reassurance-section"
      className="bg-white py-24 md:py-32 border-y border-slate-200"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="bg-[#F4F6F4] border border-slate-200 rounded-2xl p-8 md:p-12 lg:p-14">
          <div className="cmyk-ribbon h-1 w-16 mb-8 rounded-full" aria-hidden />
          <div className="flex items-center gap-3 mb-6">
            <span className="w-12 h-12 rounded-xl bg-teal text-white flex items-center justify-center">
              <ShieldCheck className="w-6 h-6" strokeWidth={2} />
            </span>
            <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-teal">
              Quick reassurance
            </span>
          </div>
          <h2
            data-testid="supplies-reassurance-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            We Match Everything{" "}
            <span className="text-teal">For You.</span>
          </h2>
          <ul className="mt-8 space-y-4 max-w-2xl">
            {POINTS.map((p, i) => (
              <li
                key={p}
                data-testid={`supplies-reassurance-point-${i}`}
                className="flex items-start gap-3"
              >
                <span className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-teal/20 border border-teal/40 flex items-center justify-center">
                  <Check className="w-3.5 h-3.5 text-teal" strokeWidth={3} />
                </span>
                <span className="text-lg sm:text-xl text-navy font-semibold leading-snug">
                  {p}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
